module.exports = __webpack_public_path__ + "static/media/ashokleyland_login.58c4a399.jpg";